import _ from 'lodash';

export default (engagements, engagementMetadata) =>{
	let engagementsMetadata = [];

	if(!_.isEmpty(engagementMetadata)){
		engagements?.forEach((engagement) => {
			let enMetadata = engagementMetadata?.find(
				(engMetadata) => engMetadata.id === engagement
			);

			if (enMetadata !== undefined) {
				engagementsMetadata.push(enMetadata);
			}
		});
	}
	
	return engagementsMetadata;
}
